// extracted by mini-css-extract-plugin
export default {"similarityLabel":"YiYFTdQPN8goFjG1NGEc","similarityResult":"CAg3Q3ZEHYAkBg_MTBOQ","similarityEmpty":"SYNr2j0dheYIkHn024f3"};